export type LicenseScope = 'PERSONAL_USE' | 'CONCURRENT_USE';
